export const BenzingaKoreaLogo = () => {
  return <img alt="Benzinga Korea 한국" height="53" src="/next-assets/images/logos/bz-logo-korea.jpeg" width="501" />;
};

export default BenzingaKoreaLogo;
